import request from '../network';
import { download, downloadPost } from '../network';

export const getBoughtDictApi = () => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/getBoughtDict',
    method: 'GET',
  });
};

export const getStatusDictApi = () => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/getStatusDict',
    method: 'GET',
  });
};

export const getGoodsRecommendListApi = (data: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/list',
    method: 'POST',
    data,
  });
};

export const addOrUpdateGoodsRecommendApi = (data: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/addOrUpdate',
    method: 'POST',
    data,
  });
};

export const getGoodsRecommendDetailApi = (params: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/detail',
    method: 'GET',
    params,
  });
};

export const deleteGoodsRecommendApi = (data: { shopId: number | string; id: number | string }) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/delete',
    method: 'POST',
    data,
  });
};

export const batchDeleteGoodsRecommendApi = (data: { shopId: number | string; ids: Array<number | string> }) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/batchDelete',
    method: 'POST',
    data,
  });
};

export const getGoodsRecommendTaskListApi = (data: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/task/list',
    method: 'POST',
    data,
  });
};

export const addOrUpdateGoodsRecommendTaskAndGoodsApi = (data: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/task/addOrUpdateTaskAndGoods',
    method: 'POST',
    data,
  });
};

export const getGoodsRecommendTaskDetailApi = (params: any) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/task/detail',
    method: 'GET',
    params,
  });
};

export const getGoodsRecommendDetailListApi = (data: { shopId: number | string; taskId: number | string }) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/detailList',
    method: 'POST',
    data,
  });
};

export const deleteGoodsRecommendTaskApi = (data: { shopId: number | string; id: number | string }) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/task/delete',
    method: 'POST',
    data,
  });
};

export const changeGoodsRecommendTaskStatusApi = (data: {
  shopId: number | string;
  id: number | string;
  status: number;
}) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/task/changeStatus',
    method: 'POST',
    data,
  });
};
export const downloadGoodsRecommendTemplateApi = (platform?: string | null) => {
  const query = platform ? `?platform=${encodeURIComponent(platform)}` : '';
  return download(`/member/royalcanin/admin/goodsRecommend/importTemplate${query}`);
};

export const exportGoodsRecommendDataApi = (payload: { platform?: string | null; data: any }) => {
  const query = payload.platform ? `?platform=${encodeURIComponent(payload.platform)}` : '';
  return downloadPost(`/member/royalcanin/admin/goodsRecommend/export${query}`, payload.data);
};

export const importGoodsRecommendDataApi = (payload: {
  shopId: any;
  taskId?: number | string | null;
  platform?: string | null;
  file: File;
}) => {
  const formData = new FormData();
  formData.append('file', payload.file);
  const query = new URLSearchParams();
  query.append('shopId', String(payload.shopId));
  if (payload.taskId !== undefined && payload.taskId !== null && payload.taskId !== '') {
    query.append('taskId', String(payload.taskId));
  }
  if (payload.platform) query.append('platform', payload.platform);
  return request({
    url: `/member/royalcanin/admin/goodsRecommend/importData?${query.toString()}`,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getGoodsRecommendImportResultApi = (params: {
  shopId: number | string;
  importStartTime: number | string;
}) => {
  return request({
    url: '/member/royalcanin/admin/goodsRecommend/importData/result',
    method: 'GET',
    params,
  });
};
